<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="pointer">
            <defs>
                <path id="9uab4w8foa" d="M7.2 14.118c-.22 0-.439-.084-.613-.253L.287 7.75C.104 7.57 0 7.32 0 7.059c0-.262.104-.511.287-.69l6.3-6.117C6.952-.102 7.521-.08 7.86.3c.339.38.318.977-.046 1.33L2.223 7.06l5.59 5.429c.364.353.385.947.046 1.33-.176.199-.417.3-.659.3"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <g class="adjust" transform="translate(-18 -26) translate(24 31)">
                    <mask id="3spgy11m0c" fill="#fff">
                        <use xlink:href="#9uab4w8foa"/>
                    </mask>
                    <g class="path" :fill="fill" mask="url(#3spgy11m0c)">
                        <path :d="`M0 0H${height}V${width}H0z`"/>
                    </g>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-pointer',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        position: {
            type: String,
            default: 'left'
        },
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>